import bgShape from '../../assets/registration/bg-shape.png';
import shape1 from '../../assets/registration/shape-1.png';
import pulpalSvg from '../../assets/registration/pulpal.svg';
import eye from '../../assets/eye-solid.svg';
import eyeSlash from '../../assets/eye-slash-solid.svg';
import info from '../../assets/circle-info-solid.svg';

export const RegistrationResources = {
    bgShape, shape1, pulpalSvg, eye, eyeSlash, info
}